import { useEffect, useRef } from 'react';

const useEventListener = (
  eventName,
  handler,
  isEnable,
  element = typeof window !== 'undefined' ? window : null
) => {
  const savedHandler = useRef(handler);
  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(() => {
    if (!element?.addEventListener || !isEnable) return;

    const listener = (event) => {
      savedHandler.current(event);
    };
    element.addEventListener(eventName, listener);
    return () => {
      element.removeEventListener(eventName, listener);
    };
  }, [eventName, element, isEnable]);
};

export default useEventListener;